import React from "react"
import Countdown, { zeroPad } from "react-countdown-now"
import { BASE_HEADING } from "constants/general-style"
import { withRadium, DetectCompact } from "higher-order-components"
import { WysiwygContent } from "components"


const CountdownTimer = ({
  completeDate, topContentCountdownTimer = "Entries Close In", completeContent = "", compact
}) => {
  const countDate = new Date()
  if (completeDate) {
    countDate.setTime(completeDate)
  } else {
    countDate.setDate(countDate.getDate() + 1)
  }
  return (
    <div style={{ textAlign: "center" }}>
      <div style={DigitStyles.heading}>{topContentCountdownTimer}</div>
      <Countdown
        date={countDate}
        renderer={props => (
          <div>
            {!props.completed && (
              <div style={DigitStyles.timer}>
                <div>
                  <div style={compact ? DigitStyles.compactSpan : DigitStyles.span}>
                    {zeroPad(props.days)}
                  </div>
                  <div style={DigitStyles.descriptor}>Days</div>
                </div>
                <div style={compact ? DigitStyles.compactSeperator : DigitStyles.seperator}>:</div>
                <div>
                  <div style={compact ? DigitStyles.compactSpan : DigitStyles.span}>
                    {zeroPad(props.hours)}
                  </div>
                  <div style={DigitStyles.descriptor}>Hours</div>
                </div>
                <div style={compact ? DigitStyles.compactSeperator : DigitStyles.seperator}>:</div>
                <div>
                  <div style={compact ? DigitStyles.compactSpan : DigitStyles.span}>
                    {zeroPad(props.minutes)}
                  </div>
                  <div style={DigitStyles.descriptor}>Minutes</div>
                </div>
                <div style={compact ? DigitStyles.compactSeperator : DigitStyles.seperator}>:</div>
                <div>
                  <div style={compact ? DigitStyles.compactSpan : DigitStyles.span}>
                    {zeroPad(props.seconds)}
                  </div>
                  <div style={DigitStyles.descriptor}>Seconds</div>
                </div>
              </div>
            )}
            {props.completed && (
              <WysiwygContent
                xmlString={completeContent} />
            )}
          </div>
        )} />
    </div>
  )
}

export default withRadium(DetectCompact())(CountdownTimer)

const DigitStyles = {
  heading: {
    ...BASE_HEADING,
    fontWeight: 200,
    color: "#FFF"
  },
  descriptor: {
    ...BASE_HEADING,
    fontSize: "0.8em",
    fontWeight: 200,
    color: "#FFF"
  },
  timer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    flexWrap: "no-wrap",
    marginTop: "5px"
  },
  timerColumn: {
    display: "flex",
    flexDirection: "column"
  },
  span: {
    fontSize: "3.2em",
    padding: "0 10px",
    fontWeight: 700,
    letterSpacing: "6px"
  },
  compactSpan: {
    fontSize: "2em",
    padding: "0 5px",
    fontWeight: 700,
    letterSpacing: "4px"
  },
  compactSeperator: {
    fontSize: "2em",
    fontWeight: 700
  },
  seperator: {
    fontSize: "3.2em",
    fontWeight: 700
  }
}



// WEBPACK FOOTER //
// ./src/components/countdown-timer/index.jsx